"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsQueryParam = void 0;
var AnalyticsQueryParam;
(function (AnalyticsQueryParam) {
    AnalyticsQueryParam["source"] = "pushNotificationSource";
})(AnalyticsQueryParam = exports.AnalyticsQueryParam || (exports.AnalyticsQueryParam = {}));
//# sourceMappingURL=analyticsLabels.js.map